<template>
	<div>
		<div class="bookmark d-flex align-items-center justify-content-center" v-if="bookmark">
			<h1 class="mb-0 py-2 px-3">{{ bookmark }}</h1>
		</div>
		<div class="content-container">
			<choice-message
					v-bind:format="format"
					v-bind:message="message"
			/>
		</div>
	</div>
</template>

<script>
	import ChoiceMessage from './choice-message'

	export default {
		name: 'choice',
		components: {
			ChoiceMessage
		},
		props: {
			format: {
				type: String,
				required: true
			},
			message: {
				type: String,
				required: true
			},
			bookmark: {
				type: String,
				required: true
			}
		}
	}
</script>